import { paths } from "../../app/paths";
import { StatusPage } from "./StatusPage";

export function NotFoundPage() {
  return (
    <StatusPage
      code="Error 404"
      title="This page doesn't exist"
      action={{ href: paths.home, label: "Go to the home page" }}
    >
      <p>Check the address for typos, or start again from the home page.</p>
    </StatusPage>
  );
}
